(function(iz) {
	iz.GetProgrami = GetProgrami;
	
	function GetProgrami(poduzece, samoWeb) {
		samoWeb = typeof samoWeb === 'boolean' ? samoWeb : true;
		
		return $.dsDirectCall({
			method: "GetProgrami",
			params: [poduzece, samoWeb]
		});	
	}
	
	function GetPopisGrupaKor(){
		return $.dsDirectCall({
			method: "iz/GetPopisGrupaKor"
		});		
	}
}(konto.iz));